"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//#endregion
/**
 *
 * @see https://github.com/caesay/ts-get-safe
 */
function safeGet() {
    var args = Array.prototype.slice.call(arguments);
    var obj = args[0];
    var path = args.slice(1).join('.');
    return get(obj, path);
}
exports.default = safeGet;
function get(obj, key) {
    var p = 0;
    var keyArr = key.split('.');
    while (obj && p < keyArr.length)
        obj = obj[keyArr[p++]];
    return obj;
}
//# sourceMappingURL=safe-get.js.map